/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 */
import React from 'react';
import { Modal } from '../../../shared/modals/Modal';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import type { TrialExpiredPromptCopy } from '../../../../../../shared/billing-catalog';
import { spacing } from '../../../shared/theme/spacing'
import { typography } from '../../../shared/theme/typography'
import { ticketColors, ticketFonts } from '../../../shared/theme/ticketColors';

type PlanLapsedModalProps = {
  visible: boolean;
  copy: TrialExpiredPromptCopy;
  busy?: boolean;
  onChoosePlan: () => void;
  onDismiss: () => void;
};

export function PlanLapsedModal({
  visible,
  copy,
  busy = false,
  onChoosePlan,
  onDismiss,
}: PlanLapsedModalProps) {
  return (
    <Modal visible={visible} transparent animationType="fade" onRequestClose={onDismiss}>
      <View style={styles.backdrop}>
        <View style={styles.card} accessibilityViewIsModal>
          <Text style={styles.title}>{copy.title}</Text>
          <Text style={styles.body}>{copy.body}</Text>
          <View style={styles.list}>
            {copy.bullets.map((item) => (
              <Text key={item} style={styles.bullet}>
                • {item}
              </Text>
            ))}
          </View>
          <TouchableOpacity
            style={[styles.primaryBtn, busy && styles.btnDisabled]}
            onPress={onChoosePlan}
            disabled={busy}
            accessibilityRole="button"
          >
            <Text style={styles.primaryBtnText}>{copy.choosePlanLabel}</Text>
          </TouchableOpacity>
          <TouchableOpacity
            style={styles.secondaryBtn}
            onPress={onDismiss}
            disabled={busy}
            accessibilityRole="button"
          >
            <Text style={styles.secondaryBtnText}>{copy.dismissLabel}</Text>
          </TouchableOpacity>
        </View>
      </View>
    </Modal>
  );
}

const styles = StyleSheet.create({
  backdrop: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.55)',
    justifyContent: 'center',
    padding: spacing.lg,
  },
  card: {
    borderRadius: 20,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
    padding: spacing.lg,
    gap: spacing.md,
    maxWidth: 420,
    width: '100%',
    alignSelf: 'center',
  },
  title: {
    ...typography.titleLg,
    fontFamily: ticketFonts.sans,
    color: ticketColors.ink,
    fontWeight: '800',
  },
  body: {
    ...typography.body,
    fontFamily: ticketFonts.sans,
    color: ticketColors.ink2,
    lineHeight: 22,
  },
  list: {
    gap: spacing.xs,
  },
  bullet: {
    ...typography.caption,
    fontFamily: ticketFonts.sans,
    color: ticketColors.ink2,
    lineHeight: 20,
  },
  primaryBtn: {
    borderRadius: 10,
    backgroundColor: ticketColors.gold,
    paddingVertical: spacing.md,
    alignItems: 'center',
  },
  primaryBtnText: {
    fontFamily: ticketFonts.sans,
    color: ticketColors.goldInk,
    fontWeight: '800',
    fontSize: 16,
  },
  secondaryBtn: {
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper2,
    paddingVertical: spacing.sm,
    alignItems: 'center',
  },
  secondaryBtnText: {
    fontFamily: ticketFonts.sans,
    color: ticketColors.ink,
    fontWeight: '700',
  },
  btnDisabled: {
    opacity: 0.6,
  },
});
